module.exports = __webpack_public_path__ + "static/media/upload.def088c6.svg";